import React from "react";

const AimAndScope = () => {
  return (
    <section>
      <p>
        IJISSS welcomes empirical, theoretical, and methodological research that
        bridges disciplinary boundaries and applies systems approaches to solve
        real-world problems.
      </p>

      <h3 className="fw-bold text-blue font-size-21">Aim and Scope</h3>
      <ul>
        <li>
          Health systems and hospital management; public health and healthcare
          policy; nutrition
        </li>
        <li>
          Systems modeling and optimization; data science and analytics in
          decision-making
        </li>
        <li>
          Education, innovation, and technology integration; environmental
          systems and sustainability
        </li>
        <li>
          Business, economics, and operations research; social, behavioral, and
          cultural systems
        </li>
        <li>
          Governance, leadership, and institutional performance; complex systems
          and interdisciplinary frameworks
        </li>
        <li>
          All areas of engineering, business management, computer science,
          social science, physics, chemistry, and biology
        </li>
      </ul>

      <h3 className="fw-bold text-blue font-size-21">Article Types Accepted</h3>
      <ul>
        <li>Original Research Articles</li>
        <li>Review and Systematic Review Papers</li>
        <li>Conceptual and Theoretical Studies</li>
        <li>Policy Analyses</li>
        <li>Case Studies</li>
        <li>Commentaries and Editorials</li>
        <li>Short Communications</li>
        <li>Technical Notes / System Models</li>
      </ul>
    </section>
  );
};

export default AimAndScope;
